/* eslint-disable @typescript-eslint/no-unused-vars */
import {useState, useEffect} from 'react'
import * as Yup from 'yup'
import clsx from 'clsx'
import {Link, useNavigate} from 'react-router-dom'
import {useFormik} from 'formik'
import authAPI from '../../../../api/authAPI'
import {toast} from 'react-toastify'
import {toAbsoluteUrl} from '../../../../_metronic/helpers'

const initialValues = {
  new_password: '',
  confirm_password: '',
}

const forgotPasswordSchema = Yup.object().shape({
  new_password: Yup.string()
    .min(6, 'Minimum 6 characters')
    .max(50, 'Maximum 50 characters')
    .required('New Password is required'),
  confirm_password: Yup.string()
    .oneOf([Yup.ref('new_password'), null], 'Password do not match')
    .required('Confirm Password is required'),
})

export function ForgotPasswordVerrify() {
  const [loading, setLoading] = useState(false)
  const [token, setToken] = useState<string>('')

  const navigate = useNavigate()
  const formik = useFormik({
    initialValues,
    validationSchema: forgotPasswordSchema,
    onSubmit: (values, {setStatus, setSubmitting}) => {
      setLoading(true)
      //   setHasErrors(undefined)
      let data: any = {
        new_password: values?.new_password,
        confirm_password: values?.confirm_password,
        token: tokenData,
      }
      setTimeout(() => {
        authAPI
          .resetPassword(data)
          .then(
            (res: any) => {
              if (res?.data?.success === true) {
                setLoading(false)
                formik.resetForm()
                // redirect to login page
                navigate('/auth/login')
                // success message
                toast.success(res?.data?.message, {
                  theme: 'dark',
                })
              } else {
                // setIsSuccess(false)
                toast.success(res?.data?.message, {
                  theme: 'dark',
                })
              }
            },
            (err: any) => {
              console.log(err)
              if (err?.response?.data?.success === false) {
                setLoading(false)
                setSubmitting(false)
              }
            }
          )
          .catch(() => {
            setLoading(false)
            setSubmitting(false)
            setStatus('The login detail is incorrect')
          })
      }, 100)
    },
  })

  let url = window.location.href
  var tokenData = url.substring(url.lastIndexOf('/') + 1)

  // const forgetPasswordVerrify = (tokenData: string) => {
  //   if (tokenData) {
  //     let data =
  //     authAPI.forgetPassworVerrify(tokenData).then(
  //       (res: any) => {
  //         //   console.log(res)
  //         if (res?.data?.success === true) {
  //           setToken(tokenData)
  //           // setIsSuccess(true)
  //         } else {
  //           // setIsSuccess(false)
  //           setToken('')
  //           toast.error(res?.data?.message, {
  //             theme: 'dark',
  //           })
  //         }
  //       },
  //       (err: any) => {
  //         if (err?.response?.data?.success === false) {
  //           setToken('')
  //           // setIsSuccess(false)
  //           navigate('/auth/forgot-password')
  //           toast.error(err?.response?.data?.message, {
  //             theme: 'dark',
  //           })
  //         }
  //       },
  //     )
  //   }
  // }
  return (
    <div
      className='d-flex flex-column flex-lg-row flex-column-fluid h-100'
      style={{background: '#f3f3f3'}}
    >
      {/* begin::Body */}
      <div className='d-flex flex-column flex-lg-row-fluid w-lg-50 p-10 order-2 order-lg-1'>
        {/* begin::Form */}
        <div className='d-flex flex-center flex-column flex-lg-row-fluid'>
          {/* begin::Wrapper */}
          <div className='w-lg-500px d-flex justify-content-center flex-wrap'>
            <img
              src={toAbsoluteUrl('/media/logos/asteric-white.png')}
              alt='logo'
              height={80}
              className='mb-5'
            />
            <form
              className='form w-100 card p-10'
              noValidate
              id='kt_login_password_reset_form'
              onSubmit={formik.handleSubmit}
            >
              <div className='mb-10'>
                <h3 className='text-dark fw-bold mb-3'>New Password</h3>
                <hr />
              </div>

              {/* begin::Form group */}
              <>
                <div className='fv-row mb-10'>
                  <label className='form-label text-gray-900 fs-6'>New Password</label>
                  <input
                    type='password'
                    placeholder='Enter Password'
                    autoComplete='off'
                    {...formik.getFieldProps('new_password')}
                    className={clsx(
                      'form-control form-control-lg form-control-solid',
                      {
                        'is-invalid': formik.touched.new_password && formik.errors.new_password,
                      },
                      {
                        'is-valid': formik.touched.new_password && !formik.errors.new_password,
                      }
                    )}
                  />
                  {formik.touched.new_password && formik.errors.new_password && (
                    <div className='fv-plugins-message-container'>
                      <div className='fv-help-block'>
                        <span role='alert' className='alert'>
                          {formik.errors.new_password}
                        </span>
                      </div>
                    </div>
                  )}
                </div>
                {/* end::Form group */}
                <div className='fv-row mb-10'>
                  <label className='form-label text-gray-900 fs-6'>Confirm Password</label>
                  <input
                    type='password'
                    placeholder='Enter Confirm Password'
                    autoComplete='off'
                    {...formik.getFieldProps('confirm_password')}
                    className={clsx(
                      'form-control form-control-lg form-control-solid',
                      {
                        'is-invalid':
                          formik.touched.confirm_password && formik.errors.confirm_password,
                      },
                      {
                        'is-valid':
                          formik.touched.confirm_password && !formik.errors.confirm_password,
                      }
                    )}
                  />
                  {formik.touched.confirm_password && formik.errors.confirm_password && (
                    <div className='fv-plugins-message-container'>
                      <div className='fv-help-block'>
                        <span role='alert' className='alert'>
                          {formik.errors.confirm_password}
                        </span>
                      </div>
                    </div>
                  )}
                </div>
                {/* begin::Form group */}
                <div className='d-flex flex-wrap justify-content-center pb-lg-0'>
                  <button
                    type='submit'
                    id='kt_password_reset_submit'
                    style={{background: '#454743', color: '#fff', borderRadius: 50}}
                    className='btn me-4 w-100'
                  >
                    <span className='indicator-label'>Submit</span>
                    {loading && (
                      <span className='indicator-progress'>
                        Please wait...
                        <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
                      </span>
                    )}
                  </button>
                </div>
              </>
            </form>
            <div className='text-black-500 text-center fw-semibold fs-6 mt-5'>
              Remember your password?{' '}
              <Link to='/auth/login' style={{color: '#16C782'}}>
                Login here
              </Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
